import React from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { Typography } from "@mui/material";

export default function Communication({
  client,
  FORM_MODE,
  languageCodes,
  handleInputChange,
}) {
  return (
    <Grid container>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            name="TelephoneNumber"
            disabled={FORM_MODE === "LOCKED" ? true : false}
            label="Telefonnummer"
            value={client?.TelephoneNumber}
            onChange={(e) =>
              handleInputChange("TelephoneNumber", e.target.value)
            }
            size="small"
            fullWidth
            margin="dense"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            name="Email"
            disabled={FORM_MODE === "LOCKED" ? true : false}
            label="E-post"
            value={client?.Email}
            onChange={(e) => handleInputChange("Email", e.target.value)}
            size="small"
            fullWidth
            margin="dense"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            name="Website"
            disabled={FORM_MODE === "LOCKED" ? true : false}
            label="Hemsida"
            value={client?.Website}
            onChange={(e) => handleInputChange("Website", e.target.value)}
            size="small"
            fullWidth
            margin="dense"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <FormControl fullWidth sx={{ textAlign: "left" }} margin="dense">
            <InputLabel>Språkkod</InputLabel>
            <Select
              value={client.LanguageCode}
              disabled={FORM_MODE === "LOCKED" ? true : false}
              onChange={(e) =>
                handleInputChange("LanguageCode", e.target.value)
              }
              name="LanguageCode"
              label="Språkkod"
              size="small"
            >
              {languageCodes?.map((language) => (
                <MenuItem key={language.Value} value={language.Value}>
                  {language.Name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            name="CaseHandler"
            disabled={FORM_MODE === "LOCKED" ? true : false}
            label="Handläggare"
            value={client?.CaseHandler}
            onChange={(e) => handleInputChange("CaseHandler", e.target.value)}
            size="small"
            fullWidth
            margin="dense"
          />
        </Grid>
      </Grid>
      <Typography sx={{ marginTop: "1.5rem", marginBottom: "0.5rem" }}>
        Kontaktperson 1
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            name="Name"
            disabled={FORM_MODE === "LOCKED" ? true : false}
            label="Namn"
            value={client?.ContactPerson}
            onChange={(e) => handleInputChange("ContactPerson", e.target.value)}
            size="small"
            fullWidth
            margin="dense"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            name="Role"
            disabled={FORM_MODE === "LOCKED" ? true : false}
            label="Roll"
            value={client?.ContactPersonRole}
            onChange={(e) =>
              handleInputChange("ContactPersonRole", e.target.value)
            }
            size="small"
            fullWidth
            margin="dense"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            name="Email"
            disabled={FORM_MODE === "LOCKED" ? true : false}
            label="E-post"
            value={client?.ContactPersonEmail}
            onChange={(e) =>
              handleInputChange("ContactPersonEmail", e.target.value)
            }
            size="small"
            fullWidth
            margin="dense"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            name="Mobile"
            disabled={FORM_MODE === "LOCKED" ? true : false}
            label="Mobil"
            value={client?.ContactPersonMobileNumber}
            onChange={(e) =>
              handleInputChange("ContactPersonMobileNumber", e.target.value)
            }
            size="small"
            fullWidth
            margin="dense"
          />
        </Grid>
      </Grid>
      <Typography sx={{ marginTop: "1.5rem", marginBottom: "0.5rem" }}>
        Kontaktperson 2
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            name="Name"
            disabled={FORM_MODE === "LOCKED" ? true : false}
            label="Namn"
            value={client?.ContactPerson2}
            onChange={(e) =>
              handleInputChange("ContactPerson2", e.target.value)
            }
            size="small"
            fullWidth
            margin="dense"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            name="Role"
            disabled={FORM_MODE === "LOCKED" ? true : false}
            label="Roll"
            value={client?.ContactPerson2Role}
            onChange={(e) =>
              handleInputChange("ContactPerson2Role", e.target.value)
            }
            size="small"
            fullWidth
            margin="dense"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            name="Email"
            disabled={FORM_MODE === "LOCKED" ? true : false}
            label="E-post"
            value={client?.ContactPerson2Email}
            onChange={(e) =>
              handleInputChange("ContactPerson2Email", e.target.value)
            }
            size="small"
            fullWidth
            margin="dense"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            name="Mobile"
            disabled={FORM_MODE === "LOCKED" ? true : false}
            label="Mobil"
            value={client?.ContactPerson2MobileNumber}
            onChange={(e) =>
              handleInputChange("ContactPerson2MobileNumber", e.target.value)
            }
            size="small"
            fullWidth
            margin="dense"
          />
        </Grid>
      </Grid>
    </Grid>
  );
}
